"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityListResponseDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const messages_1 = require("../../../../../../../libs/service-lib/src/lib/messages");
class ContactsDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 272 }),
    tslib_1.__metadata("design:type", Number)
], ContactsDto.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "John Doe" }),
    tslib_1.__metadata("design:type", String)
], ContactsDto.prototype, "displayName", void 0);
class OpportunityDataDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 28 }),
    tslib_1.__metadata("design:type", Number)
], OpportunityDataDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 434, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityDataDto.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Viacom18 Media Private Limited", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityDataDto.prototype, "companyName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Ghmc", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityDataDto.prototype, "policyType", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityDataDto.prototype, "activityName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Under Review", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityDataDto.prototype, "stage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 53, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityDataDto.prototype, "priority", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityDataDto.prototype, "opportunityCreationDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityDataDto.prototype, "assignedTo", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityDataDto.prototype, "branch", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "2025-10-31" }),
    tslib_1.__metadata("design:type", String)
], OpportunityDataDto.prototype, "expectedCloseDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1000 }),
    tslib_1.__metadata("design:type", Number)
], OpportunityDataDto.prototype, "premium", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1000 }),
    tslib_1.__metadata("design:type", Number)
], OpportunityDataDto.prototype, "sumInsured", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 272, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityDataDto.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [ContactsDto] }),
    tslib_1.__metadata("design:type", Array)
], OpportunityDataDto.prototype, "contact", void 0);
class OpportunityResponseDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [OpportunityDataDto] }),
    tslib_1.__metadata("design:type", Array)
], OpportunityResponseDto.prototype, "data", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 17 }),
    tslib_1.__metadata("design:type", Number)
], OpportunityResponseDto.prototype, "count", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], OpportunityResponseDto.prototype, "opportunityLeads", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], OpportunityResponseDto.prototype, "opportunityProspects", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], OpportunityResponseDto.prototype, "opportunityQcr", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], OpportunityResponseDto.prototype, "opportunityClients", void 0);
class OpportunityListResponseDto {
}
exports.OpportunityListResponseDto = OpportunityListResponseDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 200 }),
    tslib_1.__metadata("design:type", Number)
], OpportunityListResponseDto.prototype, "status", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: messages_1.successMessage.opportunityListRetrieved }),
    tslib_1.__metadata("design:type", String)
], OpportunityListResponseDto.prototype, "message", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: OpportunityResponseDto }),
    tslib_1.__metadata("design:type", OpportunityResponseDto)
], OpportunityListResponseDto.prototype, "data", void 0);
